// Full-document render of the Oscar account order-detail view: PageSkeleton
// wrapping the legacy tempurpedic orders page -- the "Your Account / Your
// Orders / {number}" breadcrumbs, the "Order: {number}" heading, the CMS aux
// header, the single TP OrderDetailTracker block (the account variant, from the
// account_rich_order_json seam), and the customer-service info block (TP's
// divergent island). Breadcrumb/heading copy uses ttag `t` for tempurca (fr_CA).
import React from "react";
import { t } from "ttag";

import { interfaces, templates } from "@reactivated";

import { AuthCustomerServiceBlock } from "../components/AuthCustomerServiceBlock";
import { AuxOrderHistoryContent } from "../components/AuxOrderHistoryContent";
import { OrderDetailTracker } from "../components/OrderDetailTracker";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.OrderDetailDocumentTemplate,
): React.JSX.Element => {
    const tracker = props.account_rich_order_json
        ? (JSON.parse(
              props.account_rich_order_json,
          ) as interfaces.TPOrderTrackerInterface)
        : null;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width u-margin-bottom--xl u-full-width-title order-list">
                <section className="breadcrumbs-block">
                    <a href={props.profile_url}>{t`Your Account`}</a> /{" "}
                    <a href={props.order_list_url}>{t`Your Orders`}</a> /{" "}
                    {props.order_number}
                </section>

                <h2>
                    {t`Order:`} {props.order_number}
                </h2>

                <AuxOrderHistoryContent
                    payload={props.aux_order_history_json}
                />

                <div className="content__copy--full-width content__orders-page">
                    <div className="orders">
                        <ul className="orders__list">
                            <li className="orders__list-item">
                                <div className="content__copy--full-width order-summary-wrapper">
                                    {tracker && (
                                        <OrderDetailTracker data={tracker} />
                                    )}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <AuthCustomerServiceBlock payload={props.cs_info_json} />
        </PageSkeleton>
    );
};
